<template>
    <tbody class="loading-table-body">
        <template v-if="$store.darkMode">
            <tr v-for="index1 in 5" :key="index1">
                <td v-for="index2 in columns" :key="index2"><span></span></td>
            </tr>
        </template>
        <tr v-else>
            <td :colspan="columns"></td>
        </tr>
    </tbody>
</template>

<script>
    export default {
        name: 'LoadingTable',
        props: {
            columns: {
                type: Number,
                required: true,
            },
        },
    };
</script>
